<template>
<div class="chapter">
<div class="inner_page">
<p class="st-sp" id="intro"> </p>
<p class="fmh"><span class="epub-b">INTRODUCTION</span></p>
<p class="sau-1"><span class="epub-i">Rachel Caine</span></p>
<p class="co">When I was growing up, I used to wonder why girls never got the cool stories. You know what I mean—the tales with knights fighting for right, with detectives prowling the mean streets to solve crimes, and the gritty stories about growing up on the wrong side of the tracks.</p>
<p class="tx">Instead, the books people thought <span class="epub-i">I</span> should read were about ballerinas. About good girls who did what they were told. About women who rarely had adventures, and when they did, rarely saved themselves, or anybody else.</p>
<p class="tx">I decided I didn’t want to be the princess languishing in the tower—I wanted to be the knight battling to save her. So I grabbed all the adventure stories I could, and never looked back.</p>
<p class="tx">I’m particularly proud to be included in this collection of stories featuring powerful women, women who aren’t afraid to kick a little butt—or a lot of it—when the situation calls for it. I’m also honored to be in the company of these fantastic storytellers, who kick some stereotyping butt of their own.</p>
<p class="tx">I’m proud to be a chick—never more than now.</p>
<p class="tx">Because chicks are awesome.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// introduction.vue?65030609